import React from "react"
import { Link } from "gatsby"
import Helmet from "react-helmet"
import "./layout.scss"
import style from "./layout.module.scss"

import LogoObicis from "../assets/logo-obicis.inline.svg"

const isActive = ({ isCurrent }) => {
  return isCurrent ? { className: "active" } : {}
}

const ListLink = props => (
  <div>
    {/* <h5 style={{ display: "inline" }}> */}
    <Link getProps={isActive} to={props.to}>
      {props.children}
    </Link>
    {/* </h5> */}
  </div>
)

export default class Layout extends React.PureComponent {
  constructor(props) {
    super(props)
    this.headerLayoutRef = React.createRef()
    this.scrollingNavbar = false
    this.state = { menuOpen: false }
    this.onScrollHandler = () => {
      this.lastScrollY = window.pageYOffset

      if (this.lastScrollY > 32) {
        if (!this.scrollingNavbar) {
          this.headerLayoutRef.current.classList.add("scrolling")
          this.scrollingNavbar = true
        }
      } else {
        if (this.scrollingNavbar) {
          this.headerLayoutRef.current.classList.remove("scrolling")
          this.scrollingNavbar = false
        }
      }
    }
    this.toggleMenu = e => {
      if (e && e.target) {
        const tg = e.target
        setTimeout(() => {
          tg.blur()
        }, 10)
      }
      this.setState(({ menuOpen }) => ({ menuOpen: !menuOpen }))
    }
  }

  componentDidMount() {
    window.addEventListener("scroll", this.onScrollHandler, false)
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScrollHandler, false)
  }

  render() {
    const children = this.props.children
    const headerLayoutClassNames = ["header-layout", style.headerLayout]
    if (this.scrollingNavbar) {
      headerLayoutClassNames.push("scrolling")
    }
    if (this.state.menuOpen) {
      headerLayoutClassNames.push("open")
    }
    return (
      <div className={["main-layout", style.layout].join(" ")}>
        <Helmet>{/* <meta charSet="utf-8" /> */}</Helmet>
        <div
          className={headerLayoutClassNames.join(" ")}
          ref={this.headerLayoutRef}
        >
          <div
            className={[
              "main-layout-header",
              "container",
              style.layoutHeader,
            ].join(" ")}
          >
            <Link to="/" className={["logo-link", style.logoLink].join(" ")}>
              <LogoObicis
                className={["logo", style.logoImg].join(" ")}
                aria-label={"Obicis Logo"}
              />

              {/* <img className={["logo", style.logoImg].join(" ")} src={LogoObicis} alt="Obicis" /> */}
              {/* <h3 style={{ display: `inline` }}>Obicis</h3> */}
            </Link>

            <div
              className={["drop-menu", style.dropMenu].join(" ")}
              onClick={e => {
                e.preventDefault()
                this.toggleMenu(e)
              }}
              onKeyDown={e => {
                if (
                  e.nativeEvent.code === "Enter" ||
                  e.nativeEvent.code === "NumpadEnter" ||
                  e.nativeEvent.code === "Space"
                ) {
                  e.preventDefault()
                  this.toggleMenu(e)
                }
              }}
              tabIndex="0"
              role={"button"}
              aria-pressed={this.state.menuOpen}
              aria-label={"Main menu"}
            >
              <div
                className={["drop-menu-bar1", style.dropMenuBar1].join(" ")}
              ></div>
              <div
                className={["drop-menu-bar2", style.dropMenuBar2].join(" ")}
              ></div>
              <div
                className={["drop-menu-bar3", style.dropMenuBar3].join(" ")}
              ></div>
            </div>
          </div>
          <div
            className={[
              "main-menu-list-container",
              "container",
              style.menuListContainer,
            ].join(" ")}
          >
            <ul className={["main-menu-list", style.menuList].join(" ")}>
              <ListLink to="/">Home</ListLink>
              <ListLink to="/services/">Services</ListLink>
              <ListLink to="/contact/">Contact Us</ListLink>
            </ul>
          </div>
        </div>
        <div className={["sections-layout", style.sectionsLayout].join(" ")}>
          {children}
        </div>
        {/* <div className={["footer-overlay", style.footerOverlay].join(" ")}></div> */}
        <div className={["footer-layout", style.footerLayout].join(" ")}>
          <span>
            <b>&copy;2020 Obicis Ltd.</b>{" "}
            <Link to="/privacy-legal/">Privacy policy &amp; legal</Link>
          </span>
        </div>
      </div>
    )
  }
}
